import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import type { ReactNode } from "react";
import type { Role } from "@/lib/api";

type Props = {
  children: ReactNode;
  allowedRoles?: readonly Role[];
};

export function ProtectedRoute({ children, allowedRoles }: Props) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-slate-500">Chargement…</div>
      </div>
    );
  }

  if (auth.status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles && !allowedRoles.includes(auth.user.role)) {
    return <Navigate to="/forbidden" replace />;
  }

  // Forcer le changement de mot de passe au premier login (invitation équipe)
  if (auth.user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  return <>{children}</>;
}
